import { Layer, Group } from '@pixi/layers';

export const LAYERS = {
    BACKGROUND: new Layer(new Group(100, false)),
    BACKGROUND_OVER: new Layer(new Group(200, false)),
    UNDER_REELS: new Layer(new Group(300, false)),
    REELS: new Layer(new Group(400, false)),
    REELS_MASKED: new Layer(new Group(600, false)),
    OVER_REELS: new Layer(new Group(700, false)),
    REELS_WIN: new Layer(new Group(800, false)),
    REELS_WIN_OVER: new Layer(new Group(900, false)),
    UNDER_KEYPAD: new Layer(new Group(1000, false)),
    KEYPAD: new Layer(new Group(1100, false)),
    OVER_KEYPAD: new Layer(new Group(1200, false)),
    POPUPS: new Layer(new Group(1300, false)),
    LOADER: new Layer(new Group(1400, false)),
    SYSTEM_POPUPS: new Layer(new Group(1500, false)),
    TOP: new Layer(new Group(1600, false)),
    WATERMARK: new Layer(new Group(1700, false))
} as const;

Object.entries(LAYERS).forEach(([key, val]) => val.name = key);
